module.exports = __webpack_public_path__ + "static/media/Daniel Southwick.c2a48e20.png";